import styled from "styled-components/macro";
import { themePalette } from "../../theme";
import { featureDiscoveryColors } from "./featureDiscovery.colors";

export const FeatureDiscoveryHelpContainer = styled.section`
  padding: 0 0 24px;
`;

export const FeatureDiscoveryHelpTitle = styled.h2`
  margin: 0 0 16px;
  color: ${themePalette.greyDark};
  font-family: bold;
  font-size: 20px;
  line-height: 26px;
`;

export const FeatureDiscoveryCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`;

export const FeatureDiscoveryCard = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  box-sizing: border-box;
  background: ${featureDiscoveryColors.lavenderSurface};
  color: ${themePalette.purpleDark};
  cursor: pointer;
  font-family: bold;
  font-size: 18px;
  line-height: 24px;
  text-align: left;

  &:hover {
    background: ${featureDiscoveryColors.lavenderHover};
  }
`;

export const FeatureDiscoveryNewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 28px;
  padding: 0 10px;
  border-radius: 5px;
  box-sizing: border-box;
  background: ${featureDiscoveryColors.badgeYellow};
  color: ${themePalette.black};
  font-family: bold;
  font-size: 13px;
  line-height: 18px;
`;
